import React from 'react';
// mui components
import { Avatar, Box, Button, Stack } from '@mui/material';
// hooks
import { IArtistProfile } from 'hooks/swrRequests/useArtistProfiles';
// config
import { isStepComplete, PROFILE_STEPS } from '../steps';
// styles
import { colors } from 'styles/colors';
import { useTranslation } from 'react-i18next';

const GREEN = '#1F9D6B';

interface OwnProps {
  current: number;
  profile: IArtistProfile;
  onSelect: (index: number) => void;
}

const StepNav: React.FC<OwnProps> = ({ current, profile, onSelect }) => {
  const { t } = useTranslation();

  return (
    <Stack direction="row" sx={{ mb: 3.5, flexWrap: 'wrap', gap: 1, maxWidth: '100%' }}>
      {PROFILE_STEPS.map((step, index) => {
        const active = index === current;
        return (
          <Button
            key={step.id}
            disableRipple
            onClick={() => onSelect(index)}
            sx={{
              minHeight: 0,
              py: 1.2,
              px: 2,
              fontSize: 14,
              fontWeight: active ? 700 : 600,
              color: active ? colors.main.purple : '#8a8a8a',
              textTransform: 'none',
              borderRadius: '9px',
              border: active ? `1.5px solid ${colors.main.purple}` : '1px solid #E9E9E9',
              bgcolor: 'transparent',
              '&:hover': { bgcolor: 'transparent', color: active ? colors.main.purple : '#333' },
            }}
          >
            <Stack direction="row" spacing={1} alignItems="center">
              {isStepComplete(step, profile) ? (
                <Avatar sx={{ width: 15, height: 15, bgcolor: GREEN, fontSize: 9 }}>✓</Avatar>
              ) : (
                <Box component="span" sx={{ fontSize: 11, opacity: 0.6 }}>
                  {index + 1}
                </Box>
              )}
              <span>{t(step.label)}</span>
            </Stack>
          </Button>
        );
      })}
    </Stack>
  );
};

export default StepNav;
